import { getValue } from "@utils/lodash";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import LogSubheaderSvgComponent from "../../assets/svg-components/sub-header/log";

function BulkViewLogs(props: any) {
  const navigate = useNavigate();
  const { dropdownOptions, url, type } = props;

  const handleNavigateLogs = (name: string) => {
    // console.log(name, "NAME");
    switch (name) {
      case "SELF_COMPLIANCE_CONFIG":
        return navigate(`/file-logs/SELF_COMPLIANCE`);
      case "VENDOR_USER":
        return navigate(`/file-logs/USER`);
      case "VENDOR_HEADCOUNT":
        return navigate(`/file-logs/HEADCOUNT`);
      case "VENDOR_AUDIT_COMPLIANCE":
        return navigate(`/self-compliance-logs/VENDOR_AUDIT_COMPLIANCE`);
      case "VENDOR_AUDIT_SCORE_SITE":
        return navigate(`/self-compliance-logs/VENDOR_AUDIT_SCORE_SITE`);
      case "SELFCOMP_MASTER":
        return navigate(`/self-compliance-logs/SELFCOMP_MASTER`);
      case "SELF_COMPLIANCE_TASK_BULK_UPLOAD":
        return navigate(`/file-logs/SELF_COMPLIANCE_TASK_BULK_UPLOAD`);
      case "SELF_COMPLIANCE_CONFIG_BULK_UPLOAD":
        return navigate(`/file-logs/SELF_COMPLIANCE_CONFIG_BULK_UPLOAD`);
      case "LEGACY_TASK_MASTER":
        return navigate(`/self-compliance-logs/LEGACY_TASK_MASTER`);
      case "VENDOR_AUDIT_SCORE_VENDOR":
        return navigate(`/self-compliance-logs/VENDOR_AUDIT_SCORE_VENDOR`);
      case "VENDOR_CHECKPOINT_ALL_DOCS":
        return navigate(`/self-compliance-logs/VENDOR_CHECKPOINT_ALL_DOCS`);
      default:
        return navigate(`/file-logs/${name}`);
    }
  };
  return (
    <div className="icon-dropdown-holder ms-0">
      <ReactTooltip id="subHeaderViewLogsDD" effect="solid" place="bottom">
        View Logs
      </ReactTooltip>
      <UncontrolledDropdown>
        <DropdownToggle
          className="icons-btn"
          data-tip
          data-for="subHeaderViewLogsDD"
        >
          {/* <div className="add-filter-wrapper__filter-container">
            <div className="cursor-pointer">
              <img
                src="/images/taskback.svg"
                className="img-fluid add-filter-wrapper__upload-image"
              />
              <p className="add-filter-wrapper__filter-title">VIEW LOGS</p>
            </div>
          </div> */}
          {/* <button className="icons-btn" data-tip data-for="subHeaderViewLogsDD"> */}
          <LogSubheaderSvgComponent />
          {/* </button> */}
        </DropdownToggle>
        <DropdownMenu>
          {getValue(dropdownOptions, `length`, 0) > 0 &&
            dropdownOptions.map((item: object) => {
              // if (getValue(item, `value`, "") !== "SELF_COMPLIANCE_BULK_UPLOAD")
              return (
                <DropdownItem
                  onClick={() => {
                    handleNavigateLogs(getValue(item, `value`, ""));
                  }}
                >
                  {getValue(item, `label`, "")}
                </DropdownItem>
              );
            })}
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  );
}

export default BulkViewLogs;
